/**
 * Centralized Query Key Factories
 *
 * All TanStack Query keys are defined here to avoid key collisions
 * and enable targeted invalidation.
 */

export const platformKeys = {
	all: ["platform"] as const,
	stats: () => [...platformKeys.all, "stats"] as const,
};

export const tokenKeys = {
	all: ["tokens"] as const,
	lists: () => [...tokenKeys.all, "list"] as const,
	list: (filters: string) => [...tokenKeys.lists(), { filters }] as const,
	details: () => [...tokenKeys.all, "detail"] as const,
	detail: (id: string) => [...tokenKeys.details(), id] as const,
	trending: (limit: number) => [...tokenKeys.all, "trending", { limit }] as const,
	priceHistory: (id: string, interval: string) =>
		[...tokenKeys.all, "price-history", id, interval] as const,
	trades: (id: string) => [...tokenKeys.all, "trades", id] as const,
	holders: (id: string) => [...tokenKeys.all, "holders", id] as const,
	volumeHistory: (id: string, interval: string) =>
		[...tokenKeys.all, "volume-history", id, interval] as const,
	holderHistory: (id: string, interval: string) =>
		[...tokenKeys.all, "holder-history", id, interval] as const,
};

export const creatorKeys = {
	all: ["creator"] as const,
	tokens: (address: string | undefined) => [...creatorKeys.all, "tokens", { address }] as const,
	fees: (tokenId: string, address: string | undefined) =>
		[...creatorKeys.all, "fees", tokenId, { address }] as const,
	revenueHistory: (tokenId: string, interval: string, address: string | undefined) =>
		[...creatorKeys.all, "revenue-history", tokenId, interval, { address }] as const,
};

export const uploadKeys = {
	all: ["uploads"] as const,
};

export const adminKeys = {
	all: ["admin"] as const,
	stats: () => [...adminKeys.all, "stats"] as const,
	tokens: () => [...adminKeys.all, "tokens"] as const,
	tokenList: (filters: string) => [...adminKeys.tokens(), { filters }] as const,
};
